
<template>
 <div class="WriteInfo_wrapper">
   <div class="closeWriteModal" @click="closeWriteModal"><img src="../assets/images/close-icon.png"/></div>
   <header>
     <div class="title">拍摄并上传您的有效二代身份证照片</div>
   </header>
   <div class="uploadPic">
     <van-uploader :after-read="afterRead" multiple>
       <div class="pic">
         <img src="../assets/images/pic.jpg" />
       </div>
     </van-uploader>
 
     <div class="pic" v-for="(item, index) in imgList" :key="index">
	   <img class="deletePic" src="../assets/images/circle_close.png" @click="deletePic(index)"/>
       <img :src="item" />
     </div>
   </div>
   <footer>
     <div class="identify">
       <van-button type="primary" block class="btn" @click="upLoadOcr"
         >开始识别</van-button
       >
     </div>
   </footer>
 </div>
</template>
 
<style>
.WriteInfo_wrapper {
    width: 100vw;
    min-height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
	flex-direction: column;
    
}
.WriteInfo_wrapper .closeWriteModal{
	position: absolute;
	right: 0.3rem;
	top: 0.2rem;
}
.WriteInfo_wrapper .closeWriteModal img{
	width: 0.3rem;
}
.WriteInfo_wrapper header {
    width: 100%;
    height: 0.86rem;
    margin: 0.3rem 0 0.3rem 0.46rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.WriteInfo_wrapper header .title {
    font-size: 0.32rem;
    color: #333;
}
.WriteInfo_wrapper header .describe {
    font-size: 0.28rem;
    color: #999;
}
.WriteInfo_wrapper .uploadPic {
        padding: 0 0.4rem;
        display: flex;
        flex-wrap: wrap;
		overflow-y: auto;
		flex: 0.7;
    }
.WriteInfo_wrapper .uploadPic .pic {
    width: 3.2rem;
    height: 2.2rem;
    margin-bottom: 0.3rem;
	position: relative;
	margin-top: 0.4rem;
}
.WriteInfo_wrapper .uploadPic .pic:nth-child(2n+1) {
        margin-right: 0.3rem;
}
.WriteInfo_wrapper .uploadPic .pic img {
     width: 100%;
     height: 100%;
 }
 .WriteInfo_wrapper .uploadPic .pic .deletePic {
      position: absolute;
	  width: 0.5rem;
	  height: auto;
	  right: -10px;
	  top: -13px;
  }
.WriteInfo_wrapper .identify {
        position: fixed;
        width: 100%;
        height: 1.5rem;
        left: 0;
        bottom: 0;
        border-top: 0.01rem solid #ccc;
    }
.WriteInfo_wrapper .identify .btn {
    background-color: #28CC77;
    border-radius: 0.08rem;
    width: 6.9rem;
    height: 0.9rem;
    margin: 0.3rem 0 0 0.3rem;
}
.WriteInfo_wrapper .identify span {
    font-size: 0.36rem;
    color: #fff;
}

.div {
    width: 3.2rem;
    height: 2.2rem;
    background-color: #333;
}

@media screen and (min-width:1025px) {
	  html {
        font-size: 70px !important;
		background-color: #f6f6f6;
		overflow-x: hidden;
    }
    .WriteInfo_wrapper{
		display: none;
	}
 }
 
 @media screen and (max-width:1024px) {
  	  html {
         font-size: 130px !important;
     }
 }
 
 @media screen and (max-width:768px) {
  	  html {
         font-size: 100px !important;
     }
 }
 
 @media screen and (max-width:425px) {
  	  html {
         font-size: 55px !important;
     }
 }
 
 @media screen and (max-width:375px) {
  	  html {
         font-size: 50px !important;
     }
 }
 
 @media screen and (max-width:320px) {
  	  html {
         font-size: 43px !important;
     }
 }
</style>
 
<script>
import { Button, Toast, uploader, Dialog } from "vant";
import { upLoadOcr } from '../api/api'
export default {
  name: 'WriteInformationModal',
  props: {
  	isShow:Boolean
  },
  watch: {
  	isShow(newValue, oldValue) {
  		if(this.isShow){
			this.resetData()
		}
  	}
  },
  components: {
	"van-button": Button,
    "van-uploader": uploader,
  },
  data() {
    return {
		formData: '',
		imgList: []
	  }
  }, 
  methods: {  
	afterRead(file) {
	  if (Array.isArray(file)) {
	    const fileList = new FormData();
	    file.forEach(item => {
	      fileList.append('file', item.file)
	      this.imgList.push(item.content)
	    })
	    this.formData = fileList
	  } else {
	    const formData = new FormData();
	    this.imgList.push(file.content)
	    formData.append('file', file.file)
	    this.formData = formData
	  }
	},
	async upLoadOcr() {
	  if (!this.imgList.length) {
	    return
	  }
	  Toast.loading({
	    message: '识别中...',
	    forbidClick: true,
	    duration: 0
	  })
	  const data = await upLoadOcr(this.formData)
	  Toast.clear()
	  if (+data.resCode === -1) {
	    Dialog({ message: data.resMsg });
	  } else {
	    const ocrData = data.resData
		this.$emit("confirmWriteinformation",ocrData);
		// this.resetData()
	  }
	},
	closeWriteModal(){
		// this.resetData()
		this.$emit("closewriteinformationme");
	},
	resetData(){
		this.formData= '',
		this.imgList = []
	},
	deletePic(index){
		this.imgList.splice(index,index + 1)
	}
  }
}
</script>